import React, { PropTypes } from 'react'

import styles from './HotCourse.css'


function HotCourse ({ courses, examInfo }) {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        热门课程排行榜
      </div>
      <div className={styles.body}>
        <div className={styles.courses}>
          {
            courses.map(course =>
              <div key={course.id} className={styles.course}>
                <a
                  className={styles.row}
                  href={course.link}
                  target="_blank"
                >
                  {course.name}
                </a>
                <div className={styles.detail}>
                  {course.orderCount}人购买过
                </div>
              </div>
            )
          }
        </div>
        <div className={styles.more}>
          <a>了解更多课程</a>
        </div>
        <div className={styles.examInfo}>
          <a className={styles.button} target="_blank">
            备考资讯
          </a>
          <div className={styles.detailCenter}>
            <div>{examInfo.tip}</div>
            <div>扫一扫,入群领资料</div>
          </div>
          <div className={styles.picture}>
            <img alt="一键加群" src={examInfo.image} width="100%" height="100%" />
          </div>
          <a className={styles.button} href={examInfo.link} target="_blank">
            一键加群
          </a>
        </div>
      </div>
    </div>
  )
}

HotCourse.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired
    })
  ),
  examInfo: PropTypes.shape({
    image: PropTypes.string.isRequired,
    tip: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired
  })
}


export default HotCourse



/** WEBPACK FOOTER **
 ** ./src/components/QuestionList/HotCourse.js
 **/